/** Nombre que una operación le da a un código de turno (AM/PM). */
export type OperationShift = { code: "AM" | "PM"; label: string };

/** Nombre configurado para el código en una operación, o null si no hay. */
export const configuredShiftLabel = (
  code: string | null | undefined,
  shifts: OperationShift[] | null | undefined
): string | null => {
  if (!code || !shifts) return null;
  return shifts.find((s) => s.code === code)?.label ?? null;
};

/** Nombre del código solo si todas las operaciones coinciden en él; si no, null. */
export const commonShiftLabel = (
  code: string | null | undefined,
  lists: (OperationShift[] | null | undefined)[]
): string | null => {
  if (lists.length === 0) return null;
  const labels = lists.map((l) => configuredShiftLabel(code, l));
  const first = labels[0];
  if (first === null) return null;
  return labels.every((l) => l === first) ? first : null;
};
